import { createApiRef } from '@backstage/frontend-plugin-api';

/**
 * API for interacting with the devops-secrets-storage backend (temporary secrets).
 *
 * Note: part of the backend GET endpoint is service-to-service only; calls from the browser
 * will typically be rejected unless your backend is configured to allow it.
 *
 * @public
 */
export interface SecretsStorageApi {
  getTemporarySecret(key: string): Promise<string | undefined>;
  setTemporarySecret(
    key: string,
    value: string,
    ttl_minutes?: number,
  ): Promise<void>;
  deleteTemporarySecret(key: string): Promise<void>;
}

/**
 * ApiRef for the secrets storage API (frontend).
 *
 * @public
 */
export const secretsStorageApiRef = createApiRef<SecretsStorageApi>().with({
  id: 'secrets-storage-api',
  pluginId: 'devops-secrets-storage',
});
